var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        { class: ["calendar-card", "calendar-card--theme-" + _vm.theme] },
        [
          _c(
            "div",
            { staticClass: "calendar-card__content" },
            [
              _c("date-block", {
                staticClass: "u-bottom-margin--s",
                attrs: {
                  size: "m",
                  date: _vm.data.dateFrom.timestamp,
                  "date-end": _vm.data.dateTo.timestamp,
                },
              }),
              _vm._v(" "),
              _c(
                "z-caption",
                {
                  staticClass: "calendar-card__title",
                  attrs: { size: "m", weight: "500" },
                },
                [_c("span", { domProps: { innerHTML: _vm._s(_vm.data.name) } })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.theme === "upcoming" || (_vm.data.file && _vm.data.file.link)
            ? _c(
                "div",
                { staticClass: "calendar-card__footer" },
                [
                  _vm.theme === "upcoming"
                    ? _c(
                        "remind",
                        { attrs: { data: _vm.data.remind } },
                        [
                          _c(
                            "z-button",
                            {
                              attrs: { size: "s", kind: "secondary" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "right",
                                    fn: function () {
                                      return [
                                        _c("z-icon", {
                                          attrs: {
                                            name: "calendar",
                                            width: "24",
                                            height: "24",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3404879252
                              ),
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.text.addToCalendar),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : [
                        _vm.data.file && _vm.data.file.link
                          ? _c(
                              "z-link",
                              {
                                attrs: {
                                  href: _vm.data.file.link,
                                  internal: "",
                                  "icon-position": "right",
                                  size: "s",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.text["press-release"]
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }